import { OrgUsageTrendsResponse } from "@/pages/credits/types";
import { Stack } from "@altimateai/lego";

interface TopUsersCardProps {
  users: OrgUsageTrendsResponse["top_users"]["users"];
  totalCredits: number;
}

export const TopUsersCard = ({ users, totalCredits }: TopUsersCardProps) => {
  if (users.length === 0) {
    return (
      <div className="al-flex al-items-center al-justify-center al-h-32 al-text-gray-500">
        No AI teammates data available
      </div>
    );
  }
  return (
    <div className="al-space-y-5 overflow-auto">
      {users.map((u, index) => {
        const percentage = totalCredits > 0 ? (u.credits_consumed / totalCredits) * 100 : 0;
        return (
          <Stack gap={"none"} direction={"column"} key={index} className="al-space-y-1">
            <span className="al-font-medium al-text-gray-900 al-truncate">
              {u.display_name || u.user_email}
            </span>
            <div className="al-w-full al-bg-gray-200 al-rounded-full al-h-2">
              <div
                className="al-bg-yellow-300 al-h-2 al-rounded-full al-transition-all"
                style={{ width: `${Math.min(percentage, 100)}%` }}
              />
            </div>
            <span className="al-text-gray-600 al-font-normal">
              {u.credits_consumed} credits ({percentage.toFixed(1)}%)
            </span>
          </Stack>
        );
      })}
    </div>
  );
};
